import { useEffect, useState } from "react";
import { api } from "./api";
import { setTimezone } from "./dates";

let cached = null;
export function usePerms() {
  const [p, setP] = useState(cached);
  useEffect(() => {
    let live = true;
    api.get("/me/permissions").then(r => { cached = r.data; setTimezone(r.data.timezone); if (live) setP(r.data); }).catch(() => {});
    return () => { live = false; };
  }, []);
  return p?.b2b?.perms || {};
}

export const CATEGORIES = ["1 YEAR DIPLOMA", "2 YEAR DIPLOMA", "3 YEAR DIPLOMA", "BACHELORS DEGREE", "MASTERS DEGREE"];
